<div class="wb-googlemaps-pane">
  <div class="wb-name wb-route-name">
    {{'route' | translate | ucFirst}}
  </div>
  @if (metrics) {
    <span>{{(metrics.durationDesc)}} {{'min' | translate}}, </span>
  }
  @if (metrics) {
    <span>{{metrics.distanceDesc}} {{(_state.companySettings.distanceFormat  === 'km'? 'km' : 'mi' )|translate}}</span>
  }
  <div class="wb-googlemaps-container {{(buttonstyle==='squared'? 'wb-squared' : '')}}">
    @if (googleMapsLoaded && this.form.config.showRouteMap && this.data.departureModel.value) {
      <google-map [options]="options" [center]="this.options.center" height="300px" width="100%">
        <map-marker [options]="departureMarker" [position]="this.data.departureModel.value.gps"></map-marker>
        @if (getStopOvers()) {
          <span>
            <map-marker *ngFor="let stopOver of getStopOvers() index as fi;"
              [options]="stopOverMarker" [position]="stopOver.value && stopOver.value.gps">
            </map-marker>
          </span>
        }
        <map-marker [options]="destinationMarker" [position]="this.data.destinationModel && this.data.destinationModel.value && this.data.destinationModel.value.gps"></map-marker>
        @if ((directionsResults | async); as directionsResults) {
          <map-directions-renderer
            [directions]="directionsResults"
          [options]="directionsRenderOption"></map-directions-renderer>
        }
      </google-map>
    }
  </div>
</div>
